import React from 'react';
import { useQuery, gql } from '@apollo/client';
import { useState, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Paper, Typography, Link } from '@material-ui/core';

export const WebsiteNotActive = () => {
  return (
    <div style={{ margin: '32px auto' }}>
      <Paper style={{ padding: 16, margin: 16, textAlign: 'center' }}>
        <Typography variant="h5">This website is not active.</Typography>
        <Typography variant="h6" style={{ marginTop: 8 }}>
          If you run this organization,{' '}
          <Link
            href="/admin/subscription/new"
            color="inherit"
            style={{ textDecoration: 'underline' }}
          >
            click here
          </Link>{' '}
          to activate it.
        </Typography>
      </Paper>
    </div>
  );
};

const QUERY = gql`
  query PublicLayoutDesktop {
    currentUserCanEditCurrentOrganization @client
    currentOrganization @client {
      hasSubscription
      pricingVersion
    }
  }
`;

const usePublicLayoutDisabled = () => {
  const { data } = useQuery(QUERY);
  const [viewDisabled, setViewDisabled] = useState(false);
  const [searchIndexDisabled, setSearchIndexDisabled] = useState(false);
  const location = useLocation();

  useLayoutEffect(() => {
    if (!data) return;
    const { currentUserCanEditCurrentOrganization, currentOrganization } = data;
    const { hasSubscription, pricingVersion } = currentOrganization;
    const onAnnouncementPath = location.pathname.match(
      /\/announcements\/\d+\/.+/
    );

    const premiumVerWithoutSubscription = !hasSubscription;

    if (
      !currentUserCanEditCurrentOrganization &&
      premiumVerWithoutSubscription
    ) {
      setSearchIndexDisabled(true);
      if (!onAnnouncementPath) {
        setViewDisabled(true);
      }
    }
  }, [data, location.pathname]);

  return { viewDisabled, searchIndexDisabled };
};

export default usePublicLayoutDisabled;
